import React, { useState } from 'react';
import '../styles.css';

const API_BASE = 'https://api.fotomate.ai';

export default function Register() {
  const [email, setEmail]       = useState('');
  const [password, setPassword] = useState('');
  const [confirm, setConfirm]   = useState('');
  const [showPwd, setShowPwd]   = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (password !== confirm) {
      return alert('Passwords do not match');
    }

    try {
      const res = await fetch(`${API_BASE}/api/auth/register`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, password })
      });
      const data = await res.json();
      if (res.ok) {
        // registration succeeded — send them to login
        window.location.href = '/login';
      } else {
        // show the error returned by your API
        alert(data.error || 'Registration failed');
      }
    } catch (err) {
      console.error(err);
      alert('Network error');
    }
  };

  return (
    <section
      className="auth-form"
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '100vh'
      }}
    >
      <form onSubmit={handleSubmit} style={{ width: '100%', maxWidth: 400 }}>
        <table style={{ width: '100%' }}>
          <tbody>
            <tr>
              <td style={{ textAlign: 'center', paddingBottom: '1rem' }}>
                <h2>Create Account</h2>
              </td>
            </tr>
            <tr>
              <td style={{ padding: '0.5rem 0' }}>
                <input
                  type="email"
                  placeholder="Email address"
                  value={email}
                  onChange={e => setEmail(e.target.value)}
                  required
                  style={{ width: '100%', padding: '0.5rem' }}
                />
              </td>
            </tr>
            <tr>
              <td style={{ position: 'relative', padding: '0.5rem 0' }}>
                <input
                  type={showPwd ? 'text' : 'password'}
                  placeholder="Password"
                  value={password}
                  onChange={e => setPassword(e.target.value)}
                  required
                  style={{ width: '100%', padding: '0.5rem 2.5rem 0.5rem 0.5rem' }}
                  autoComplete="new-password"
                />
                <span
                  onClick={() => setShowPwd(v => !v)}
                  style={{
                    position: 'absolute',
                    right: '0.75rem',
                    top: '50%',
                    transform: 'translateY(-50%)',
                    cursor: 'pointer',
                    fontSize: '1.1rem'
                  }}
                >
                  {showPwd ? '🙈' : '👁️'}
                </span>
              </td>
            </tr>
            <tr>
              <td style={{ position: 'relative', padding: '0.5rem 0' }}>
                <input
                  type={showPwd ? 'text' : 'password'}
                  placeholder="Confirm password"
                  value={confirm}
                  onChange={e => setConfirm(e.target.value)}
                  required
                  style={{ width: '100%', padding: '0.5rem 2.5rem 0.5rem 0.5rem' }}
                  autoComplete="new-password"
                />
                <span
                  onClick={() => setShowPwd(v => !v)}
                  style={{
                    position: 'absolute',
                    right: '0.75rem',
                    top: '50%',
                    transform: 'translateY(-50%)',
                    cursor: 'pointer',
                    fontSize: '1.1rem'
                  }}
                >
                  {showPwd ? '🙈' : '👁️'}
                </span>
              </td>
            </tr>
            <tr>
              <td style={{ paddingTop: '1rem' }}>
                <button type="submit" style={{ width: '100%', padding: '0.75rem' }}>
                  Register
                </button>
              </td>
            </tr>
            <tr>
              <td style={{ textAlign: 'center', paddingTop: '1rem' }}>
                <p className="small">
                  By registering, you agree to our{' '}
                  <a href="/terms">Terms of Service</a> and{' '}
                  <a href="/privacy">Privacy Policy</a>.
                </p>
              </td>
            </tr>
            <tr>
              <td>
                <p className="small" style={{ textAlign: 'center', marginTop: '1rem' }}>
                  Already have an account?{' '}
                  <a href="/login">Log in</a>
                </p>
              </td>
            </tr>
          </tbody>
        </table>
      </form>
    </section>
  );
}
